var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',_vm._l((_vm.form),function(input){return _c('div',{key:input.id,staticClass:"mb-3"},[_c(input.component,_vm._b({tag:"component",on:{"onChangeElement":_vm.handleChangeComponent}},'component',input.props,false))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }